// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { IMAGEAPI } from "../../../../BackendConnections";
// import PdfDonutChart from "../../../utils/graphs/PdfDonutChart";
// import "./Pdf.css";
// import { useRef } from "react";

// export const Pdf = React.forwardRef((props, ref) => {
//   function insertPageBreak(email, maxLength, breakLength) {
//     if (email.length <= maxLength) {
//       return email;
//     }

//     const firstPart = email.substring(0, maxLength - breakLength);
//     const secondPart = email.substring(maxLength - breakLength);

//     return `${firstPart}
//     ${secondPart}`;
//   }
//   const overallExp = () => {
//     let total = [];
//     total +=
//       props?.profile?.secondary_jobTitle_experience +
//       props?.profile?.primary_jobTitle_experience +
//       props?.profile?.tertiary_jobTitle_experience;
//     return total;
//   };
//   const datasStyle = {
//     display: "flex",
//     justifyContent: "space-between",
//   };

//   const rightSideStyle = {
//     marginLeft: "auto",
//   };
//   var months = [
//     "Jan",
//     "Feb",
//     "Mar",
//     "Apr",
//     "May",
//     "Jun",
//     "Jul",
//     "Aug",
//     "Sept",
//     "Oct",
//     "Nov",
//     "Dec",
//   ];

//   const conversionDate = (date) => {
//     var now = new Date(date);
//     return months[now.getMonth()] + "-" + now.getFullYear();
//   };

//   const [paid, setPaid] = useState(props.paid);
//   const svgRef = useRef(null);
//   return (
//     <div ref={ref}>
//       {props.data &&
//         props.data.map((user, index) => {
//           return (
//             <div className="generate-pdf-container generate-pdf4" key={index}>
//               <div className="generate-pdf-row">
//                 <div className="generate-pdf-col-1 d-flex flex-column">
//                   <div className="sec">
//                     <figure className="profpic text-center">
//                       <div className="profile-preview">
//                         <div className="img-wrap">
//                           <div className="hexagon-wrap">
//                             <svg
//                               ref={svgRef}
//                               version="1.1"
//                               xmlns="http://www.w3.org/2000/svg"
//                               xmlnsXlink="http://www.w3.org/1999/xlink"
//                               viewBox="0 0 190 100"
//                             >
//                               <defs>
//                                 <pattern
//                                   id="imgupload"
//                                   patternUnits="userSpaceOnUse"
//                                   width="150"
//                                   height="100"
//                                 >
//                                   <image
//                                     xlinkHref={IMAGEAPI + user.profile_pic}
//                                     x="-25"
//                                     width="150"
//                                     height="100"
//                                   ></image>
//                                 </pattern>
//                               </defs>
//                               <polygon
//                                 fill="url(#imgupload)"
//                                 points="25.457,92.51 0.914,50 25.457,7.49 74.543,7.49 99.086,50 74.543,92.51 "
//                               ></polygon>
//                             </svg>
//                             {/* <img src={IMAGEAPI + user.profile_pic} alt=""  className="profile" style={{marginRight:'100px'}}/> */}
//                           </div>
//                         </div>
//                       </div>
//                     </figure>
//                     <div className="line"></div>
//                     <h1>
//                       {user.first_name} {user.last_name}
//                     </h1>
//                     {paid ? (
//                       <p className="text-center" style={{ fontSize: "13px" }}>
//                         <strong>goneet</strong>{" "}
//                         <span
//                           style={{
//                             background: "#283270",
//                             color: "white",
//                             padding: "3px",
//                             borderRadius: "2px",
//                           }}
//                         >
//                           PRO
//                         </span>{" "}
//                         Energy Profile
//                       </p>
//                     ) : (
//                       <p className="text-center" style={{ fontSize: "13px" }}>
//                         <strong>goneet</strong>{" "}
//                         {/* <span
//                           style={{
//                             background: "#283270",
//                             color: "white",
//                             padding: "3px",
//                             borderRadius: "2px",
//                           }}
//                         >
//                           PRO
//                         </span>{" "} */}
//                         Energy Profile
//                       </p>
//                     )}
//                   </div>
//                   <div className="sec">
//                     <div className="head">
//                       <h3>CONTACT</h3>
//                       <Link to="">
//                         <img src="img/linkedin.png" alt="" />
//                       </Link>
//                     </div>
//                     <div className="datas bluespan">
//                       <div>
//                         <span>
//                           <Link to="">
//                             E :{" "}
//                             {user.email.length <= 32
//                               ? user.email
//                               : insertPageBreak(user.email, 32, 6)}
//                           </Link>
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="sec">
//                     <div className="head">
//                       <h3>
//                         QUALIFICATIONS<sup>*</sup>
//                       </h3>
//                     </div>
//                     <div className="datas">
//                       <div>
//                         {user.education &&
//                           user.education.slice(0, 3).map((row, index) => {
//                             return <span key={index}>{row.education}</span>;
//                           })}
//                       </div>
//                       {/* &nbsp;
//                       <div className="sec desc">
//                         <p>
//                           *Only the top three educational qualifications are
//                           displayed here for brevity. The candidate's full
//                           profile includes additional qualifications
//                         </p>
//                       </div> */}
//                     </div>
//                   </div>
//                   <div className="sec">
//                     <div className="head">
//                       <h3>PRIMARY JOB </h3>
//                     </div>
//                     <div className="datas">
//                       <div>{user?.primary_job_title}</div>
//                     </div>
//                   </div>
//                   <div className="sec">
//                     <div className="head">
//                       <h3>EXPERIENCE</h3>
//                       <h3>(Yrs)</h3>
//                     </div>
//                     <div style={datasStyle}>
//                       <p style={{ fontSize: "14px" }}>Sector Overall</p>
//                       <div style={rightSideStyle}>{overallExp()}</div>
//                     </div>
//                     <div style={datasStyle}>
//                       <p style={{ fontSize: "14px" }}>Primary Job </p>
//                       <div style={rightSideStyle}>
//                         {props?.profile?.primary_jobTitle_experience}
//                       </div>
//                     </div>
//                     <div style={datasStyle}>
//                       <p style={{ fontSize: "14px" }}>Secondary Job </p>
//                       <div style={rightSideStyle}>
//                         {props?.profile?.secondary_jobTitle_experience}
//                       </div>
//                     </div>
//                   </div>
//                   <div className="sec">
//                     <div className="head">
//                       <h3>REGIONAL EXPERIENCE</h3>
//                     </div>
//                     <div className="datas">
//                       <p style={{ fontSize: "14px" }}>
//                         {user.primary_sector_region}
//                       </p>
//                       <p style={{ fontSize: "14px" }}>
//                         {user.secondary_sector_region}
//                       </p>
//                     </div>
//                   </div>
//                   <div className="sec">
//                     <div className="head">
//                       <h3>REFERENCES</h3>
//                     </div>
//                     <div className="datas">
//                       <p style={{ fontSize: "14px" }}>Reference available online</p>
//                     </div>
//                   </div>
//                   <div className="sec">
//                     <div className="head">
//                       <h3>EMPLOYMENT STATUS</h3>
//                     </div>
//                     <div className="datas">
//                       <p style={{ fontSize: "14px" }}>
//                         {user.seeking_employment
//                           ? "Available"
//                           : "Non Available"}
//                       </p>
//                     </div>
//                   </div>

//                   {paid ? (
//                     <div className="sec">
//                       <div className="head ">
//                         <h3>PRIMARY JOB RANKING</h3>
//                       </div>
//                       <div className="datas">
//                         <div className="row generate-graphs">
//                           <div className="generate-gr-col-12">
//                             <div className="generate-graph-title">
//                               OVERALL PEER GROUP RANKING
//                             </div>
//                             <div className="generate-graph-wrap">
//                               <div className="generate-graph-block ">
//                                 <PdfDonutChart
//                                   data={{
//                                     // value: props?.donutData?.user_ranking,
//                                     value:
//                                       props?.donutData?.user_profile_score_pro,
//                                     totalPeer:
//                                       props?.donutData
//                                         ?.PEER_Group_Overall_count,
//                                     text: props?.donutData?.user_ranking,
//                                     bgcolor: "#d3eaf3",
//                                     type: "",
//                                     isDisplayVal: true,
//                                     position: "top",
//                                   }}
//                                 />
//                               </div>
//                               <div className="generate-graph-title">
//                                 ENERGY CRITERIA RANKING
//                               </div>
//                             </div>
//                           </div>
//                           <div className="generate-gr-col br-1 bb-1">
//                             <div className="generate-graph-wrap">
//                               <div className="generate-graph-block">
//                                 <PdfDonutChart
//                                   data={{
//                                     value:
//                                       props?.donutData
//                                         ?.user_experience_score_pro,
//                                     totalPeer:
//                                       props?.donutData
//                                         ?.PEER_Group_Overall_count,
//                                     text: props?.donutData
//                                       ?.user_experience_ranking,
//                                     bgcolor: "#d3eaf3",
//                                     type: "",
//                                     isDisplayVal: false,
//                                   }}
//                                 />
//                               </div>
//                               <div className="generate-graph-footer">
//                                 <div className="generate-graph-title">
//                                   EXPERIENCE
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                           <div className="generate-gr-col bb-1">
//                             <div className="generate-graph-wrap">
//                               <div className="generate-graph-block">
//                                 <PdfDonutChart
//                                   data={{
//                                     value:
//                                       props?.donutData
//                                         ?.user_qualification_score_pro,
//                                     totalPeer:
//                                       props?.donutData
//                                         ?.PEER_Group_Overall_count,
//                                     text: props?.donutData
//                                       ?.user_qualification_ranking,
//                                     bgcolor: "#d3eaf3",
//                                     type: "",
//                                     isDisplayVal: false,
//                                   }}
//                                 />
//                               </div>
//                               <div className="generate-graph-footer">
//                                 <div className="generate-graph-title">
//                                   QUALIFICATION
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                           <div className="generate-gr-col br-1">
//                             <div className="raph-wrap">
//                               <div className="generate-graph-block">
//                                 <PdfDonutChart
//                                   data={{
//                                     value: props?.donutData?.user_training_pro,
//                                     totalPeer:
//                                       props?.donutData
//                                         ?.PEER_Group_Overall_count,
//                                     text: props?.donutData
//                                       ?.user_traning_ranking,
//                                     bgcolor: "#d3eaf3",
//                                     type: "",
//                                     isDisplayVal: false,
//                                   }}
//                                 />
//                               </div>
//                               <div className="generate-graph-footer">
//                                 <div className="generate-graph-title">
//                                   TRAINING
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                           <div className="generate-gr-col">
//                             <div className="generate-graph-wrap">
//                               <div className="generate-graph-block">
//                                 <PdfDonutChart
//                                   data={{
//                                     value:
//                                       props?.donutData?.user_systems_score_pro,
//                                     totalPeer:
//                                       props?.donutData
//                                         ?.PEER_Group_Overall_count,
//                                     text: props?.donutData
//                                       ?.user_systems_ranking,
//                                     bgcolor: "#d3eaf3",
//                                     type: "",
//                                     isDisplayVal: false,
//                                   }}
//                                 />
//                               </div>
//                               <div className="generate-graph-footer">
//                                 <div className="generate-graph-title">
//                                   SYSTEMS
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   ) : (
//                     ""
//                   )}
//                   {/* <div className="sec mt-auto">
//                     <div className="d-flex">
//                       <div>
//                         {" "}
//                         <sup style={{ fontSize: "20px" }}> ©</sup>
//                       </div>
//                       <img
//                         src="\assets\images\email_template_icons\logo.png"
//                         alt="logo"
//                         style={{ height: "45px", width: "auto" }}
//                       />
//                     </div>
//                   </div> */}
//                 </div>
//                 <div className="generate-pdf-col-2">
//                   <div className="sec">
//                     <div className="head-t2">
//                       <h2>Sector Profile</h2>
//                     </div>
//                     <div className="datas">
//                       <table className="orgtable">
//                         <tr>
//                           <td>
//                             Sector : <span>{user.primary_sector}</span>
//                           </td>
//                           <td>
//                             Sector Phase :{" "}
//                             <span>{user.primary_sector_phase}</span>
//                           </td>
//                         </tr>
//                         <tr>
//                           <td>
//                             Organisation :{" "}
//                             <span>{user.primary_organisation}</span>
//                           </td>
//                           <td>
//                             Location: <span>{user.location}</span>
//                           </td>
//                         </tr>
//                         <tr>
//                           <td>
//                             Function : <span>{user.primary_function}</span>
//                           </td>
//                           <td>
//                             Category : <span>{user.primary_category}</span>
//                           </td>
//                         </tr>
//                         <tr>
//                           <td>
//                             Job Title : <span>{user.primary_job_title}</span>
//                           </td>
//                           <td>
//                             Secondary : <span>{user.secondary_jobTitle}</span>
//                           </td>
//                         </tr>
//                         <tr>
//                           <td>
//                             Tertiary: <span>{user.tertiary_job_Title}</span>
//                           </td>
//                         </tr>
//                       </table>
//                     </div>
//                   </div>
//                   <div className="sec">
//                     <div className="head-t2">
//                       <h2>Synopsis</h2>
//                     </div>
//                     <div className="datas">
//                       <p>{user.professionalSynopsis} </p>
//                     </div>
//                   </div>

//                   <div className="sec">
//                     <div className="head-t2">
//                       <h2>Training</h2>
//                     </div>
//                     <div className="datas">
//                       <div className="flex-box">
//                         <div className="w50">
//                           <h5>STATUTORY & INDUSTRY ING</h5>
//                           <ul>
//                             {user.statutory_industry
//                               .slice(0, 5)
//                               .map((row, index) => {
//                                 return (
//                                   <li key={index}>{row.statutory_training}</li>
//                                 );
//                               })}
//                           </ul>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="sec">
//                     <div className="head-t2">
//                       <h2>Systems Experience</h2>
//                     </div>
//                     <div className="datas">
//                       <table>
//                         <tbody>
//                           {user.systemExperience
//                             .slice(0, 5)
//                             .map((row, index) => (
//                               <tr key={index}>
//                                 <td>{row.system.system_experience}</td>
//                                 <td>{row.experience.experience}</td>
//                               </tr>
//                             ))}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                   <div className="sec">
//                     <div className="head-t2">
//                       <h2>Competencies</h2>
//                     </div>
//                     <div className="datas">
//                       <table>
//                         {user.competenceScore.map((row, index) => {
//                           return (
//                             <>
//                               <tr>
//                                 <td>Business Awareness Objectives</td>
//                                 <td>
//                                   {
//                                     row.businessAwarenessObjectives
//                                       .competencies_score
//                                   }
//                                 </td>
//                               </tr>
//                               <tr>
//                                 <td>Safety & Welfare Commitments</td>
//                                 <td>
//                                   {
//                                     row.safetyWelfareCommitments
//                                       .competencies_score
//                                   }
//                                 </td>
//                               </tr>
//                               <tr>
//                                 <td>
//                                   Performance Objective Setting & Measurement
//                                 </td>
//                                 <td>
//                                   {
//                                     row.performanceObjectiveSettingMeasurement
//                                       .competencies_score
//                                   }
//                                 </td>
//                               </tr>
//                               <tr>
//                                 <td>
//                                   Statutory & Regulatory Compliance Awareness
//                                 </td>
//                                 <td>
//                                   {
//                                     row.statutoryRegulatoryComplianceAwareness
//                                       .competencies_score
//                                   }
//                                 </td>
//                               </tr>
//                               <tr>
//                                 <td>HSE Compliance</td>
//                                 <td>{row.hSECompliance.competencies_score}</td>
//                               </tr>
//                               <tr>
//                                 <td>Risk Assessment & Mitigation Techniques</td>
//                                 <td>{row.riskAssessment.competencies_score}</td>
//                               </tr>
//                               <tr>
//                                 <td>Coaching & Monitoring</td>
//                                 <td>
//                                   {row.coachingMonitoring.competencies_score}
//                                 </td>
//                               </tr>
//                               <tr>
//                                 <td>
//                                   Functional & Category Interface Awareness
//                                 </td>
//                                 <td>
//                                   {
//                                     row.functionalCategoryInterfaceAwareness
//                                       .competencies_score
//                                   }
//                                 </td>
//                               </tr>
//                               <tr>
//                                 <td>Planning & Reporting Systems</td>
//                                 <td>
//                                   {
//                                     row.planningReportingSystems
//                                       .competencies_score
//                                   }
//                                 </td>
//                               </tr>
//                               <tr>
//                                 <td>Commercial & Budget Awareness</td>
//                                 <td>
//                                   {
//                                     row.commercialBudgetAwareness
//                                       .competencies_score
//                                   }
//                                 </td>
//                               </tr>
//                               <tr>
//                                 <td>
//                                   Category / Job Specific Processes & System
//                                 </td>
//                                 <td>
//                                   {
//                                     row.businessAwarenessObjectives
//                                       .competencies_score
//                                   }
//                                 </td>
//                               </tr>
//                               <tr>
//                                 <td>Control & Performing of Work Systems</td>
//                                 <td>
//                                   {row.performingWorkSystems.competencies_score}
//                                 </td>
//                               </tr>
//                             </>
//                           );
//                         })}
//                       </table>
//                     </div>
//                   </div>
//                   <div className="sec">
//                     <div className="head-t2">
//                       <h2>Employment</h2>
//                     </div>
//                     <div className="datas">
//                       {/* <div className="status">
//                         <b>Status</b> :{" "}
//                         {user.seeking_employment
//                           ? "Available"
//                           : "Not Available"}
//                       </div> */}
//                       <table className="twotable ftable">
//                         <tbody>
//                           {user.employmentHistory
//                             .slice(0, 5)
//                             .map((row, index) => (
//                               <tr key={index}>
//                                 <td>{row.company_name}</td>
//                                 <td>{row?.selected_job_title?.job_title}</td>
//                                 <td>
//                                   {conversionDate(row.from_date)} -{" "}
//                                   {row.till_date
//                                     ? "To Date"
//                                     : conversionDate(row.to_date)}
//                                 </td>
//                               </tr>
//                             ))}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="sec desc row" style={{marginTop:'20px'}}>
//                   <div className="sec  mt-auto col-4 " >
//                     <div className="d-flex " style={{marginLeft:'40px'}}>
//                       <div>
//                         {" "}
//                         <sup style={{ fontSize: "20px" }}> ©</sup>
//                       </div>
//                       <img
//                         src="\assets\images\email_template_icons\logo.png"
//                         alt="logo"
//                         style={{ height: "45px", width: "auto" }}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-8 ">
//                     <p style={{marginLeft:'40px'}}>
//                       <sup>*</sup>
//                       Only the top three educational qualifications are
//                       displayed here for brevity. 
//                       The candidate's full profile
//                       includes additional qualifications
//                     </p>
//                   </div>

//                 </div>
//               </div>
//             </div>
//           );
//         })}
//     </div>
//   );
// });




import React, { useState } from "react";
import { Link } from "react-router-dom";
import { IMAGEAPI } from "../../../../BackendConnections";
import PdfDonutChart from "../../../utils/graphs/PdfDonutChart";
import "./Pdf.css";
import { useRef } from "react";

export const Pdf = React.forwardRef((props, ref) => {
  function insertPageBreak(email, maxLength, breakLength) {
    if (email.length <= maxLength) {
      return email;
    }

    const firstPart = email.substring(0, maxLength - breakLength);
    const secondPart = email.substring(maxLength - breakLength);

    return `${firstPart}
    ${secondPart}`;
  }
  const overallExp = () => {
    let total = [];
    total +=
      props?.profile?.secondary_jobTitle_experience +
      props?.profile?.primary_jobTitle_experience +
      props?.profile?.tertiary_jobTitle_experience;
    return total;
  };
  const datasStyle = {
    display: "flex",
    justifyContent: "space-between",
  };

  const rightSideStyle = {
    marginLeft: "auto",
  };
  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  const conversionDate = (date) => {
    var now = new Date(date);
    return months[now.getMonth()] + "-" + now.getFullYear();
  };

  const [paid, setPaid] = useState(props.paid);
  const svgRef = useRef(null);
  return (
    <div ref={ref}>
      {props.data &&
        props.data.map((user, index) => {
          return (
            <div className="generate-pdf-container generate-pdf4" key={index}>
              <div className="generate-pdf-row">
                <div className="generate-pdf-col-1 d-flex flex-column">
                  <div className="sec">
                    <figure className="profpic text-center">
                      <div className="profile-preview">
                        <div className="img-wrap">
                          <div className="hexagon-wrap">
                            <svg
                              ref={svgRef}
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              viewBox="0 0 190 100"
                            >
                              <defs>
                                <pattern
                                  id="imgupload"
                                  patternUnits="userSpaceOnUse"
                                  width="150"
                                  height="100"
                                >
                                  <image
                                    xlinkHref={IMAGEAPI + user.profile_pic}
                                    x="-25"
                                    width="150"
                                    height="100"
                                  ></image>
                                </pattern>
                              </defs>
                              <polygon
                                fill="url(#imgupload)"
                                points="25.457,92.51 0.914,50 25.457,7.49 74.543,7.49 99.086,50 74.543,92.51 "
                              ></polygon>
                            </svg>
                            {/* <img src={IMAGEAPI + user.profile_pic} alt=""  className="profile" style={{marginRight:'100px'}}/> */}
                          </div>
                        </div>
                      </div>
                    </figure>
                    <div className="line"></div>
                    <h1>
                      {user.first_name} {user.last_name}
                    </h1>
                    {paid ? (
                      <p className="text-center" style={{ fontSize: "13px" }}>
                        <strong>goneet</strong>{" "}
                        <span
                          style={{
                            background: "#283270",
                            color: "white",
                            padding: "3px",
                            borderRadius: "2px",
                          }}
                        >
                          PRO
                        </span>{" "}
                        Energy Profile
                      </p>
                    ) : (
                      <p className="text-center" style={{ fontSize: "13px" }}>
                        <strong>goneet</strong>{" "}
                        {/* <span
                          style={{
                            background: "#283270",
                            color: "white",
                            padding: "3px",
                            borderRadius: "2px",
                          }}
                        >
                          PRO
                        </span>{" "} */}
                        Energy Profile
                      </p>
                    )}
                  </div>
                  <div className="sec">
                    <div className="head">
                      <h3>CONTACT</h3>
                      <Link to="">
                        <img src="img/linkedin.png" alt="" />
                      </Link>
                    </div>
                    <div className="datas bluespan">
                      <div>
                        <span>
                          <Link to="">
                            E :{" "}
                            {user.email.length <= 32
                              ? user.email
                              : insertPageBreak(user.email, 32, 6)}
                          </Link>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="sec">
                    <div className="head">
                      <h3>
                        QUALIFICATIONS<sup>*</sup>
                      </h3>
                    </div>
                    <div className="datas">
                      <div style={{ fontSize: "13px" }}>
                        {user.education &&
                          user.education.slice(0, 3).map((row, index) => {
                            return <span key={index}>{row.education}</span>;
                          })}
                      </div>
                      {/* &nbsp;
                      <div className="sec desc">
                        <p>
                          *Only the top three educational qualifications are
                          displayed here for brevity. The candidate's full
                          profile includes additional qualifications
                        </p>
                      </div> */}
                    </div>
                  </div>
                  <div className="sec">
                    <div className="head">
                      <h3>PRIMARY JOB </h3>
                    </div>
                    <div className="datas">
                      <div style={{fontSize:"13px"}}>{user?.primary_job_title}</div>
                    </div>
                  </div>
                  <div className="sec">
                    <div className="head">
                      <h3>EXPERIENCE</h3>
                      <h3>(Yrs)</h3>
                    </div>
                    <div style={datasStyle}>
                      <p style={{ fontSize: "13px" }}>Sector Overall</p>
                      <div style={{ fontSize: "13px" }}>{overallExp()}</div>
                    </div>
                    <div style={datasStyle}>
                      <p style={{ fontSize: "13px" }}>Primary Job </p>
                      <div style={{ fontSize: "13px" }}>
                        {props?.profile?.primary_jobTitle_experience}
                      </div>
                    </div>
                    <div style={datasStyle}>
                      <p style={{ fontSize: "13px" }}>Secondary Job </p>
                      <div style={{ fontSize: "13px" }}>
                        {props?.profile?.secondary_jobTitle_experience}
                      </div>
                    </div>
                  </div>
                  <div className="sec">
                    <div className="head">
                      <h3>REGIONAL EXPERIENCE</h3>
                    </div>
                    <div className="datas">
                      <p style={{ fontSize: "13px" }}>
                        {user.primary_sector_region}
                      </p>
                      <p style={{ fontSize: "13px" }}>
                        {user.secondary_sector_region}
                      </p>
                    </div>
                  </div>
                  {/* <div className="sec">
                    <div className="head">
                      <h3>REFERENCES</h3>
                    </div>
                    <div className="datas">
                      <p style={{ fontSize: "14px" }}>Reference available online</p>
                    </div>
                  </div> */}
                  <div className="sec">
                    <div className="head">
                      <h3>EMPLOYMENT STATUS</h3>
                    </div>
                    <div className="datas">
                      <p style={{ fontSize: "13px" }}>
                        {user.seeking_employment
                          ? "Available"
                          : "Non Available"}
                      </p>
                    </div>
                  </div>

                  {paid ? (
                    <div className="sec">
                      <div className="head ">
                        <h3>PRIMARY JOB RANKING</h3>
                      </div>
                      <div className="datas">
                        <div className="row generate-graphs">
                          <div className="generate-gr-col-12">
                            <div className="generate-graph-title">
                              OVERALL PEER GROUP RANKING
                            </div>
                            <div className="generate-graph-wrap">
                              <div className="generate-graph-block ">
                                <PdfDonutChart
                                  data={{
                                    // value: props?.donutData?.user_ranking,
                                    value:
                                      props?.donutData?.user_profile_score_pro,
                                    totalPeer:
                                      props?.donutData
                                        ?.PEER_Group_Overall_count,
                                    text: props?.donutData?.user_ranking,
                                    bgcolor: "#d3eaf3",
                                    type: "",
                                    isDisplayVal: true,
                                    position: "top",
                                  }}
                                />
                              </div>
                              <div className="generate-graph-title">
                                ENERGY CRITERIA RANKING
                              </div>
                            </div>
                          </div>
                          <div className="generate-gr-col br-1 bb-1">
                            <div className="generate-graph-wrap">
                              <div className="generate-graph-block">
                                <PdfDonutChart
                                  data={{
                                    value:
                                      props?.donutData
                                        ?.user_experience_score_pro,
                                    totalPeer:
                                      props?.donutData
                                        ?.PEER_Group_Overall_count,
                                    text: props?.donutData
                                      ?.user_experience_ranking,
                                    bgcolor: "#d3eaf3",
                                    type: "",
                                    isDisplayVal: false,
                                  }}
                                />
                              </div>
                              <div className="generate-graph-footer">
                                <div className="generate-graph-title">
                                  EXPERIENCE
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="generate-gr-col bb-1">
                            <div className="generate-graph-wrap">
                              <div className="generate-graph-block">
                                <PdfDonutChart
                                  data={{
                                    value:
                                      props?.donutData
                                        ?.user_qualification_score_pro,
                                    totalPeer:
                                      props?.donutData
                                        ?.PEER_Group_Overall_count,
                                    text: props?.donutData
                                      ?.user_qualification_ranking,
                                    bgcolor: "#d3eaf3",
                                    type: "",
                                    isDisplayVal: false,
                                  }}
                                />
                              </div>
                              <div className="generate-graph-footer">
                                <div className="generate-graph-title">
                                  QUALIFICATION
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="generate-gr-col br-1">
                            <div className="raph-wrap">
                              <div className="generate-graph-block">
                                <PdfDonutChart
                                  data={{
                                    value: props?.donutData?.user_training_pro,
                                    totalPeer:
                                      props?.donutData
                                        ?.PEER_Group_Overall_count,
                                    text: props?.donutData
                                      ?.user_traning_ranking,
                                    bgcolor: "#d3eaf3",
                                    type: "",
                                    isDisplayVal: false,
                                  }}
                                />
                              </div>
                              <div className="generate-graph-footer">
                                <div className="generate-graph-title">
                                  TRAINING
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="generate-gr-col">
                            <div className="generate-graph-wrap">
                              <div className="generate-graph-block">
                                <PdfDonutChart
                                  data={{
                                    value:
                                      props?.donutData?.user_systems_score_pro,
                                    totalPeer:
                                      props?.donutData
                                        ?.PEER_Group_Overall_count,
                                    text: props?.donutData
                                      ?.user_systems_ranking,
                                    bgcolor: "#d3eaf3",
                                    type: "",
                                    isDisplayVal: false,
                                  }}
                                />
                              </div>
                              <div className="generate-graph-footer">
                                <div className="generate-graph-title">
                                  SYSTEMS
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* <div className="sec mt-auto">
                    <div className="d-flex">
                      <div>
                        {" "}
                        <sup style={{ fontSize: "20px" }}> ©</sup>
                      </div>
                      <img
                        src="\assets\images\email_template_icons\logo.png"
                        alt="logo"
                        style={{ height: "45px", width: "auto" }}
                      />
                    </div>
                  </div> */}
                </div>
                <div className="generate-pdf-col-2">
                  <div className="sec">
                    <div className="head-t2">
                      <h2>Sector Profile</h2>
                    </div>
                    <div className="datas">
                      <table className="orgtable">
                        <tr>
                          <td>
                            Sector : <span>{user.primary_sector}</span>
                          </td>
                          <td>
                            Sector Phase :{" "}
                            <span>{user.primary_sector_phase}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Organisation :{" "}
                            <span>{user.primary_organisation}</span>
                          </td>
                          <td>
                            Location: <span>{user.location}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Function : <span>{user.primary_function}</span>
                          </td>
                          <td>
                            Category : <span>{user.primary_category}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Job Title : <span>{user.primary_job_title}</span>
                          </td>
                          <td>
                            Secondary : <span>{user.secondary_jobTitle}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Tertiary: <span>{user.tertiary_job_Title}</span>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div className="sec">
                    <div className="head-t2">
                      <h2>Synopsis</h2>
                    </div>
                    <div className="datas">
                      <p>{user.professionalSynopsis} </p>
                    </div>
                  </div>

                  <div className="sec">
                    <div className="head-t2">
                      <h2>Training</h2>
                    </div>
                    <div className="datas">
                      <div className="flex-box">
                        <div className="w50">
                          <h5>STATUTORY & INDUSTRY TRAINING</h5>
                          {/* <ul>
                            {user.statutory_industry
                              .slice(0, 5)
                              .map((row, index) => {
                                return (
                                  <li style={{fontSize:"15px"}} key={index}>{row.statutory_training}</li>
                                );
                              })}
                          </ul> */}

                          <table className="training-table">
                          <tbody>
                            {user.statutory_industry.slice(0, 5).map((row, index) => (
                              <tr key={index}>
                                <td style={{fontSize:"12px"}}>{row.statutory_training}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="sec">
                    <div className="head-t2">
                      <h2>Systems Experience</h2>
                    </div>
                    <div className="datas">
                      <table>
                        <tbody>
                          {user.systemExperience
                            .slice(0, 5)
                            .map((row, index) => (
                              <tr key={index}>
                                <td style={{fontSize:"12px"}}>{row.system.system_experience}</td>
                                <td style={{fontSize:"12px"}}>{row.experience.experience}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="sec">
                    <div className="head-t2">
                      <h2>Competencies</h2>
                    </div>
                    <div className="datas">
                      <table className="competencies-table">
                        <tbody>
                          {user.competenceScore.map((row, index) => (
                            <React.Fragment key={index}>
                              {/* <tr>
                                <td style={{fontSize:"12px"}}>Business Awareness Objectives</td>
                                <td style={{fontSize:"12px"}}>{row.businessAwarenessObjectives.competencies_score}</td>
                              </tr>
                              <tr>
                                <td style={{fontSize:"12px"}}>Safety & Welfare Commitments</td>
                                <td style={{fontSize:"12px"}}>{row.safetyWelfareCommitments.competencies_score}</td>
                              </tr>
                              <tr>
                                <td style={{fontSize:"12px"}}>Performance Objective Setting & Measurement</td>
                                <td style={{fontSize:"12px"}}>
                                  {
                                    row.performanceObjectiveSettingMeasurement
                                      .competencies_score
                                  }
                                </td>
                              </tr> */}
                              <tr>
                                <td style={{fontSize:"12px"}}>Statutory & Regulatory Compliance Awareness</td>
                                <td style={{fontSize:"12px"}}>
                                  {
                                    row.statutoryRegulatoryComplianceAwareness
                                      .competencies_score
                                  }
                                </td>
                              </tr>
                              <tr>
                                <td style={{fontSize:"12px"}}>HSE Compliance</td>
                                <td style={{fontSize:"12px"}}>{row.hSECompliance.competencies_score}</td>
                              </tr>
                              <tr>
                                <td style={{fontSize:"12px"}}>Risk Assessment & Mitigation Techniques</td>
                                <td style={{fontSize:"12px"}}>{row.riskAssessment.competencies_score}</td>
                              </tr>
                              <tr>
                                <td style={{fontSize:"12px"}}>Coaching & Monitoring</td>
                                <td style={{fontSize:"12px"}}>{row.coachingMonitoring.competencies_score}</td>
                              </tr>
                              <tr>
                                <td style={{fontSize:"12px"}}>Functional & Category Interface Awareness</td>
                                <td style={{fontSize:"12px"}}>
                                  {
                                    row.functionalCategoryInterfaceAwareness
                                      .competencies_score
                                  }
                                </td>
                              </tr>
                              <tr>
                                <td style={{fontSize:"12px"}}>Planning & Reporting Systems</td>
                                <td style={{fontSize:"12px"}}>{row.planningReportingSystems.competencies_score}</td>
                              </tr>
                              <tr>
                                <td style={{fontSize:"12px"}}>Commercial & Budget Awareness</td>
                                <td style={{fontSize:"12px"}}>{row.commercialBudgetAwareness.competencies_score}</td>
                              </tr>
                              <tr>
                                <td style={{fontSize:"12px"}}>Category / Job Specific Processes & System</td>
                                <td style={{fontSize:"12px"}}>
                                  {row.businessAwarenessObjectives.competencies_score}
                                </td>
                              </tr>
                              <tr>
                                <td style={{fontSize:"12px"}}>Control & Performing of Work Systems</td>
                                <td style={{fontSize:"12px"}}>{row.performingWorkSystems.competencies_score}</td>
                              </tr>
                            </React.Fragment>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>


                  <div className="sec">
                    <div className="head-t2">
                      <h2>Employment</h2>
                    </div>
                    <div className="datas">
                      {/* <div className="status">
                        <b>Status</b> :{" "}
                        {user.seeking_employment
                          ? "Available"
                          : "Not Available"}
                      </div> */}
                      <table className="twotable ftable">
                        <tbody>
                          {user.employmentHistory
                            .slice(0, 6)
                            .map((row, index) => (
                              <tr key={index}>
                                <td style={{fontSize:"12px"}}>{row.company_name}</td>
                                <td style={{fontSize:"12px"}}>{row?.selected_job_title?.job_title}</td>
                                <td style={{fontSize:"12px"}}>
                                  {conversionDate(row.from_date)} -{" "}
                                  {row.till_date
                                    ? "To Date"
                                    : conversionDate(row.to_date)}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="sec desc row" style={{marginTop:'20px'}}>
                  <div className="sec  mt-auto col-4 " >
                    <div className="d-flex " style={{marginLeft:'40px'}}>
                      <div>
                        {" "}
                        <sup style={{ fontSize: "20px" }}> ©</sup>
                      </div>
                      <img
                        src="\assets\images\email_template_icons\logo.png"
                        alt="logo"
                        style={{ height: "45px", width: "auto" }}
                      />
                    </div>
                  </div>
                  <div className="col-8 ">
                    <p style={{marginLeft:'40px'}}>
                      <sup>*</sup>
                      Only the top three educational qualifications are
                      displayed here for brevity. 
                      The candidate's full profile
                      includes additional qualifications
                    </p>
                  </div>

                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
});
